import React from 'react';
import Header from '../../Header/Header';
import css from '../Signin.module.css';

const RevokedUser = (props) => {
    return (
        <div>
            <Header />
            <br />
            <br />
            <div className={css.error}>
                Your access has been revoked. Kindly contact your <b>Administrator</b>
            </div>
        </div>
    );
};

export default RevokedUser;
